<template>
    <icon-base v-bind="$props">
        <path d="M4 20h16" />
        <rect x="6" y="12" width="3" height="8" />
        <rect x="11" y="8" width="3" height="12" />
        <rect x="16" y="4" width="3" height="16" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
